<div class="px-3 py-2 d-flex justify-content-between align-items-center border-bottom">
  <div class="d-flex flex-column">
    <span class="fw-bold"><i class="pi pi-objects-column me-2"></i>Elementos <p-badge [value]="elements.length"
        severity="secondary" /></span>
    <small class="text-muted">{{componentModel.name}}</small>
  </div>
  <div class="d-flex gap-1">
    <p-button icon="pi pi-trash" [text]="true" size="small" [disabled]="active" (onClick)="delete()" />
    <p-button icon="pi pi-plus" [text]="true" size="small" [disabled]="active" (onClick)="newElement()" />
    <app-custom-modal #elementModal [label]="'Elementos'" [width]="'30rem'" [header]="'Elementos'"
      [children]="elementRegisterModal" [inputs$]="inputsForRegister$" [output$]="output$"
      (params)="reloadList($event.reload)" hidden>
    </app-custom-modal>
  </div>
</div>

<div class="list-group list-group-flush">
  @for (elem of elements; track elem.elementId) {
  <button class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-0"
    [class.active-item]="selectedElement.elementId === elem.elementId" (click)="elementSelected(elem)">
    {{ elem.code}} - {{elem.name }}
    <i class="pi pi-chevron-right small"></i>
  </button>
  }
</div>